<template>
    <transition name="fade" mode="out-in">
        <div class="row">
            <div class="col-12">
                <div class="block has-no-top-margin">
                    <h2>{{$t('auth.header_reset_password')}}</h2>

                    <form class="form">
                        <transition name="fade">
                            <span class="floating-label" v-show="oldPassword">{{$t('auth.old_password')}}</span>
                        </transition>
                        <div class="form__group">
                            <i class="form__input__icon mdi mdi-account-key"></i>
                            <input class="form__input--text underline has-icon" type="password" autocomplete="password" name="password" v-model="oldPassword" :placeholder="$t('auth.old_password')"/>
                        </div>

                        <div class="form__group">
                            <transition name="fade">
                                <span class="floating-label" v-show="password">{{$t('auth.new_password')}}</span>
                            </transition>
                            <i class="form__input__icon mdi mdi-account-key"></i>
                            <input class="form__input--text underline has-icon" type="password" autocomplete="password" name="password" v-model="password" :placeholder="$t('auth.new_password')"/>
                        </div>

                        <div class="form__group">
                            <transition name="fade">
                                <span class="floating-label" v-show="repeatPassword">{{$t('auth.repeat_new_password')}}</span>
                            </transition>
                            <i class="form__input__icon mdi mdi-account-key"></i>
                            <input class="form__input--text underline has-icon" type="password" autocomplete="password" name="password" v-model="repeatPassword" :placeholder="$t('auth.repeat_new_password')"/>
                        </div>

                        <div class="form__buttons">
                            <button type="submit" :disabled="!canSubmit" :class="{loading: submitting}"
                                    class="button--cta" @click.prevent="sumbit">
                                {{$t('auth.button_change_password')}}
                            </button>
                            <router-link :to="{ name: 'account'}" type="button" tag="button" class="button pull-left">{{$t('auth.button_cancel')}}</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import {SUBMIT_PASSWORD_CHANGE} from '../../store/modules/auth';


    @Component
    export default class ChangePassword extends Vue {
        oldPassword = '';
        password = '';
        repeatPassword = '';
        submitting = false;

        created() {
            window.scrollTo(0,0);
        }

        async sumbit(){
            this.submitting = true;
            try {
                const payload = {old_password: this.oldPassword, password: this.password, repeat_password: this.repeatPassword};
                await this.$store.dispatch(SUBMIT_PASSWORD_CHANGE, payload);
                this.$notify.success(this.$t('form.account_info.notify_success'));
            } catch (e) {
                //this.$notify.error(e);
                this.$notify.error(this.$t('form.account_info.notify_failure_change_password'));
            } finally {
                this.submitting = false;
                this.oldPassword = '';
                this.password = '';
                this.repeatPassword = '';
            }
        }

        get canSubmit() {
            //CHECK IF FILLED
            return !this.submitting
                && this.oldPassword.trim() != ''
                && this.password == this.repeatPassword
                && this.password.trim() != '';
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/account/ChangePassword.vue